import { cn } from "@/shared/lib/cn";

// `new URL(..., import.meta.url)` instead of `import url from "*.svg"`: Vite rewrites both to the
// hashed asset at build time, but only this form also loads under Node, so components that show
// the logo stay renderable in the node:test unit suite.
const pulsewiseIconUrl = new URL("./assets/pulsewise-icon.svg", import.meta.url).href;
const pulsewiseLogoUrl = new URL("./assets/pulsewise-logo.svg", import.meta.url).href;
const pulsewiseLogoDarkUrl = new URL("./assets/pulsewise-logo-dark.svg", import.meta.url).href;

export function LogoMark({ className }: { className?: string }) {
  return (
    <img
      src={pulsewiseIconUrl}
      alt=""
      aria-hidden="true"
      className={cn("size-7 shrink-0 object-contain", className)}
    />
  );
}

export function LogoWordmark({ className }: { className?: string }) {
  // reason: wordmark sits between text-sm (13px) and text-lg (16px) by design and
  // preserves the lockup proportions defined in the original Pulsewise brand source.
  return (
    <span className={cn("font-semibold tracking-tight text-[15px]", className)}>Pulsewise</span>
  );
}

export function LogoLockup({
  className,
  showBeta = true,
}: {
  className?: string;
  showBeta?: boolean;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <span className="block dark:hidden">
        <BrandLogoImage src={pulsewiseLogoUrl} />
      </span>
      <span className="hidden dark:block">
        <BrandLogoImage src={pulsewiseLogoDarkUrl} />
      </span>
      {showBeta ? (
        <span className="rounded-full bg-violet-100 px-1.5 py-0.5 text-3xs font-semibold uppercase tracking-wider text-violet-700 dark:bg-violet-600/20 dark:text-violet-300">
          Beta
        </span>
      ) : null}
    </div>
  );
}

function BrandLogoImage({ src }: { src: string }) {
  return <img src={src} alt="Pulsewise" className="h-9 w-auto min-w-0 object-contain" />;
}
